import { PerformanceActionTypes } from './performance.types'
import { API_CONSTANTS } from '../../utils/AppConstants'

const INITIAL_STATE = {
    newPeformanceRequestSuccess: null,
    newPeformanceRequestError: null,
    newPeformanceRequestReqStatus: '',
    performanceRequestListSuccess: null,
    performanceRequestListError: null,
    newPerformanceReviewSuccess: null,
    newPerformanceReviewError: null,
    newPerformanceReviewReqStatus: '',
    peformanceReviewListSuccess: null,
    peformanceReviewListError: null,
    newPeformanceGoalSuccess: null,
    newPeformanceGoalError: null,
    newPeformanceGoalReqStatus: '',
    peformanceGoalListSuccess: null,
    peformanceGoalListError: null,
    peformanceGoalDetailSuccess: null,
    peformanceGoalDetailError: null,
    peformanceGoalAddCommentSuccess: null,
    peformanceGoalAddCommentError: null,
    peformanceGoalAddCommentReqStatus: '',
    peformanceUpdateGoalSuccess: null,
    peformanceUpdateGoalError: null,
    peformanceUpdateGoalReqStatus: ''
}

const peformanceReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case PerformanceActionTypes.PEFORMANCE_NEW_REQUEST_SUCCESS:
            return {
                ...state,
                newPeformanceRequestSuccess: action.payload,
                newPeformanceRequestError: null,
                newPeformanceRequestReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case PerformanceActionTypes.PEFORMANCE_NEW_REQUEST_ERROR:
            return {
                ...state,
                newPeformanceRequestSuccess: null,
                newPeformanceRequestError: action.payload,
                newPeformanceRequestReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case PerformanceActionTypes.PEFORMANCE_NEW_REQUEST_STATUS:
            return {
                ...state,
                newPeformanceRequestReqStatus: ''
            }
        case PerformanceActionTypes.PEFORMANCE_REQUEST_LIST_REQUEST_SUCCESS:
            return {
                ...state,
                performanceRequestListSuccess: action.payload,
                performanceRequestListError: null
            }
        case PerformanceActionTypes.PEFORMANCE_REQUEST_LIST_REQUEST_ERROR:
            return {
                ...state,
                performanceRequestListSuccess: null,
                performanceRequestListError: action.payload
            }
        case PerformanceActionTypes.PERFORMANCE_NEW_REVIEW_REQUEST_SUCCESS:
            return {
                ...state,
                newPerformanceReviewSuccess: action.payload,
                newPerformanceReviewError: null,
                newPerformanceReviewReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case PerformanceActionTypes.PERFORMANCE_NEW_REVIEW_REQUEST_ERROR:
            return {
                ...state,
                newPerformanceReviewSuccess: null,
                newPerformanceReviewError: action.payload,
                newPerformanceReviewReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case PerformanceActionTypes.PERFORMANCE_NEW_REVIEW_REQUEST_STATUS:
            return {
                ...state,
                newPerformanceReviewReqStatus: ''
            }
        case PerformanceActionTypes.PEFORMANCE_REVIEW_LIST_REQUEST_SUCCESS:
            return {
                ...state,
                peformanceReviewListSuccess: action.payload,
                peformanceReviewListError: null
            }
        case PerformanceActionTypes.PEFORMANCE_REVIEW_LIST_REQUEST_ERROR:
            return {
                ...state,
                peformanceReviewListSuccess: null,
                peformanceReviewListError: action.payload
            }
        case PerformanceActionTypes.PEFORMANCE_NEW_GOAL_REQUEST_SUCCESS:
            return {
                ...state,
                newPeformanceGoalSuccess: action.payload,
                newPeformanceGoalError: null,
                newPeformanceGoalReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case PerformanceActionTypes.PEFORMANCE_NEW_GOAL_REQUEST_ERROR:
            return {
                ...state,
                newPeformanceGoalSuccess: null,
                newPeformanceGoalError: action.payload,
                newPeformanceGoalReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case PerformanceActionTypes.PEFORMANCE_NEW_GOAL_REQUEST_STATUS:
            return {
                ...state,
                newPeformanceGoalReqStatus: ''
            }
        case PerformanceActionTypes.PEFORMANCE_GOAL_LIST_REQUEST_SUCCESS:
            return {
                ...state,
                peformanceGoalListSuccess: action.payload,
                peformanceGoalListError: null
            }
        case PerformanceActionTypes.PEFORMANCE_GOAL_LIST_REQUEST_ERROR:
            return {
                ...state,
                peformanceGoalListSuccess: null,
                peformanceGoalListError: action.payload
            }
        case PerformanceActionTypes.PEFORMANCE_GOAL_DETAILS_REQUEST_SUCCESS:
            return {
                ...state,
                peformanceGoalDetailSuccess: action.payload,
                peformanceGoalDetailError: null
            }
        case PerformanceActionTypes.PEFORMANCE_GOAL_DETAILS_REQUEST_ERROR:
            return {
                ...state,
                peformanceGoalDetailSuccess: null,
                peformanceGoalDetailError: action.payload
            }
        case PerformanceActionTypes.PEFORMANCE_ADD_GOAL_COMMENT_REQUEST_SUCCESS:
            return {
                ...state,
                peformanceGoalAddCommentSuccess: action.payload,
                peformanceGoalAddCommentError: null,
                peformanceGoalAddCommentReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case PerformanceActionTypes.PEFORMANCE_ADD_GOAL_COMMENT_REQUEST_ERROR:
            return {
                ...state,
                peformanceGoalAddCommentSuccess: null,
                peformanceGoalAddCommentError: action.payload,
                peformanceGoalAddCommentReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case PerformanceActionTypes.PEFORMANCE_ADD_GOAL_COMMENT_REQUEST_STATUS:
            return {
                ...state,
                peformanceGoalAddCommentReqStatus: ''
            }
        case PerformanceActionTypes.PEFORMANCE_UPDATE_GOAL_REQUEST_SUCCESS:
            return {
                ...state,
                peformanceUpdateGoalSuccess: action.payload,
                peformanceUpdateGoalError: null,
                peformanceUpdateGoalReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case PerformanceActionTypes.PEFORMANCE_UPDATE_GOAL_REQUEST_ERROR:
            return {
                ...state,
                peformanceUpdateGoalSuccess: null,
                peformanceUpdateGoalError: action.payload,
                peformanceUpdateGoalReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case PerformanceActionTypes.PEFORMANCE_UPDATE_GOAL_REQUEST_STATUS:
            return {
                ...state,
                peformanceUpdateGoalReqStatus: ''
            }
        case PerformanceActionTypes.LOGOUT:
            return INITIAL_STATE
        default:
            return state
    }
}

export default peformanceReducer